import { typography } from '../global/typography';
export const MuiPaginationItem = {
    MuiPaginationItem: {
        styleOverrides: {
            root: {
                fontSize: typography.pxToRem(14),
                fontWeight: 600,
            },
        },
    },
};
